// extracted by mini-css-extract-plugin
export default {"editor":"Notes_editor__C6FNa","charCount":"Notes_charCount__0iN3y"};